import type {
  MainNavigationMenuItem,
  MainNavigationGroupItem,
  MainNavigationItemRouteRule,
} from "./types";

export const checkIsActive = (pathname: string, rule?: MainNavigationItemRouteRule) => {
  if (!rule) {
    return false;
  }

  if (typeof rule === "function") {
    return rule(pathname);
  }

  return rule.some((singleRule) => pathname.startsWith(singleRule));
};

export const findGroupForMenuItem = (
  menuItemId: string | undefined,
  primaryItems: (MainNavigationGroupItem | MainNavigationMenuItem)[]
): string | undefined => {
  if (!menuItemId) return undefined;

  for (const item of primaryItems) {
    if ("items" in item) {
      const foundInGroup = item.items
        .flatMap((section) => section.items)
        .some((menuItem) => menuItem.id === menuItemId);

      if (foundInGroup) {
        return item.id;
      }
    }
  }

  return undefined;
};
